import { withAppContext } from '@/config/site'
import request from '@/utils/request'

export const sendAuthCode = async (payload = {}) => {
  const response = await request('/page/auth/send-code', {
    data: withAppContext(payload)
  })

  return response.data || {}
}

export const registerMember = async (payload = {}) => {
  const response = await request('/page/auth/register', {
    data: withAppContext(payload)
  })

  return response.data || {}
}

export const loginMember = async (payload = {}) => {
  const response = await request('/page/auth/login', {
    data: withAppContext(payload)
  })

  return response.data || {}
}

export const resetMemberPassword = async (payload = {}) => {
  const response = await request('/page/auth/reset-password', {
    data: withAppContext(payload)
  })

  return response.data || []
}

export const fetchProfile = async () => {
  const response = await request('/page/auth/profile', {
    data: {}
  })

  return response.data || {}
}

export const logoutMember = async () => {
  const response = await request('/page/auth/logout', {
    data: {}
  })

  return response.data || []
}
